import { GruppoTerritoriale } from '../../models/gruppo-territoriale';

export class PermessoCustom {
  writePermission: GruppoTerritoriale;
  readPermission: GruppoTerritoriale;
}